// extracted by mini-css-extract-plugin
module.exports = {"button":"_2a2678","highlightText":"_a15d4e","container":"_d67aa5","text":"_c631f4","hiddenText":"_19e755","ellipsis":"_e0a2db"};